import { toTitleCase } from 'helpers';
import {
    consumptionTypeIcons,
    consumptionTypeLabels,
    convertDeliveryStatusToDisplayName,
    ticketTriggerToDisplayName,
} from 'lib/constants';
import { IssueCauseIcon } from '../IssueCauseIcon/IssueCauseIcon';

/** Return the appropriate user-friendly filter label based on the filter group. */
export const getUserFriendlyLabel = (
    filterGroupName: string,
    filterName: string
): string => {
    if (filterGroupName === 'Usage Type')
        return consumptionTypeLabels[filterName] ?? filterName;
    // Delivery types + groups have a weird, specific formatting.
    else if (
        filterGroupName === 'Delivery Type' ||
        filterGroupName === 'Groups'
    )
        return filterName;
    else if (filterGroupName === 'Status')
        return (
            convertDeliveryStatusToDisplayName[filterName] ??
            toTitleCase(filterName)
        );
    else if (filterGroupName === 'Issue Cause') {
        return (
            ticketTriggerToDisplayName[filterName] ?? toTitleCase(filterName)
        );
    } else return toTitleCase(filterName);
};

/** Return the corresponding icon to go with certain filters. */
export const getFilterOptionIcon = (
    filterGroupName: string,
    filterName: string
): JSX.Element | null => {
    if (filterGroupName === 'Usage Type') {
        return consumptionTypeIcons[filterName];
    } else if (filterGroupName === 'Issue Cause') {
        return <IssueCauseIcon trigger={filterName} />;
    }

    return null;
};
